import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable, map, take } from 'rxjs';
import { getSessionAuthData } from '../states/session-auth/session-auth.selectors';
import { sessionAuthData } from '../interfaces/states-data';

export const SessionAuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {

  const store = inject(Store<any>);
  const router = inject(Router);

  const invalidRoute = route.data['invalidRoute'] ? route.data['invalidRoute'] : 'auth';

  return store.pipe(
    select(getSessionAuthData),
    take(1),
    map((data: sessionAuthData) => {
      if (data.loggedIn) {
        return data.loggedIn;
      } else {
        // AUTH-017: pasar la URL original como queryParam para que el login pueda
        // volver al destino tras autenticar. Solo paths same-origin (state.url ya es
        // relativo a /, no acepta protocolo externo).
        const returnUrl = state.url && state.url !== '/' && state.url !== '/auth'
          ? state.url
          : null;
        router.navigate([invalidRoute], returnUrl ? { queryParams: { returnUrl } } : undefined);
        return data.loggedIn;
      }
    })
  );
};
